export const getSearchParams = (search: string) => {
  return Object.fromEntries(new URLSearchParams(search));
};
